module.exports = __webpack_public_path__ + "img/4.1.7de6f0ee.jpg";